import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About Us`}</h1>
    <p>{`He watched as the young man tried to impress everyone in the room with his intelligence. There was no doubt that he was smart.
The fact that he was more intelligent than anyone else in the room could have been easily deduced, but nobody was really paying any
attention due to the fact that it was also obvious that the young man only cared about his intelligence.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      